import { render, staticRenderFns } from "./QuickLinks.vue?vue&type=template&id=e90ad0aa&"
import script from "./QuickLinks.vue?vue&type=script&lang=ts&"
export * from "./QuickLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports